import { useContext } from 'react';

import { ThemeContext } from '../theme';

const useTheme = () => {
  const theme = useContext(ThemeContext);

  if (!theme) {
    throw new Error('Theme is missing');
  }

  return theme;
};

export default useTheme;
